export const music_audio = [
  { char: '🎸', name: 'Guitar', nameZh: '吉他/搖滾', keywords: ['music', 'band', 'rock', '樂器'], hot: true },
  { char: '🎹', name: 'Piano', nameZh: '鋼琴/古典', keywords: ['music', 'classic', 'key'] },
  { char: '🥁', name: 'Drum', nameZh: '爵士鼓/節奏', keywords: ['beat', 'rhythm', 'band'] },
  { char: '🎷', name: 'Saxophone', nameZh: '薩克斯風/藍調', keywords: ['jazz', 'music', 'wind'] },
  { char: '🎻', name: 'Violin', nameZh: '小提琴', keywords: ['string', 'classic', 'music'] },
  { char: '🎺', name: 'Trumpet', nameZh: '喇叭/慶祝', keywords: ['brass', 'sound', 'loud'] },
  { char: '🎤', name: 'Mic', nameZh: '人聲/錄音', keywords: ['sing', 'podcast', 'voice'], hot: true },
  { char: '🎧', name: 'Headphones', nameZh: '耳機監聽', keywords: ['listen', 'audio', 'music'], hot: true },
  { char: '🎼', name: 'Musical Score', nameZh: '五線譜', keywords: ['song', 'note', 'compose'] },
  { char: '🎙️', name: 'Studio Mic', nameZh: '專業錄音', keywords: ['recording', 'podcast', 'studio'], hot: true },
  { char: '📻', name: 'Radio', nameZh: '廣播/懷舊', keywords: ['old', 'broadcast', 'listen'] },
  { char: '🪗', name: 'Accordion', nameZh: '手風琴', keywords: ['folk', 'music'] },
];